import { Drawer as DrawerPrimitive } from 'vaul';
import { cn } from '@/lib/utils';

const SideDrawer = ({ open, onOpenChange, children, className }) => (
  <DrawerPrimitive.Root open={open} onOpenChange={onOpenChange} direction="left">
    <DrawerPrimitive.Portal>
      <DrawerPrimitive.Overlay className="fixed inset-0 z-50 bg-primary-900/60 backdrop-blur-sm lg:hidden" />
      <DrawerPrimitive.Content
        className={cn(
          'fixed inset-y-0 left-0 z-50 flex h-full w-[min(var(--sidebar-width),85vw)] flex-col bg-primary-800 outline-none lg:hidden',
          className
        )}
      >
        {children}
      </DrawerPrimitive.Content>
    </DrawerPrimitive.Portal>
  </DrawerPrimitive.Root>
);

export default SideDrawer;
